import { IInvolvedParty, IPageResultsResponse } from "./../../../../common/sharedTypes";
import { IWorkflowItemStep, IReport } from "../../../../common/sharedTypes";

export interface IMatchingSearchResponse {
  results: IMatchingSearchResult[];
}

export interface IMatchingSearchResult {
  workflowItemStep: IWorkflowItemStep;
  matches: IMatch[];
}

export interface IMatch {
  report: IReport;
}

export interface IMatchingQueuePagedResult {
  workflowItemStep: PartialMatchQueueItem;
  matches: IMatch[];
}

export interface ISearchMatchingQueuePagedResponse extends IPageResultsResponse {
  results: IMatchingQueuePagedResult[];
}

export class PartialMatchQueueItem {
  id?: number;
  dateOfCrash?: string | Date;
  reportType?: string;
  crashKey?: string;
  originalCrashKey?: string;
  county?: string;
  involvedParties?: string[];
  involvedPartiesFull?: IInvolvedParty[];
  mergeStatus?: string;
  mergeStatusId?: number;
  workflowStatus?: string;
  reportId?: number;
  crashReportId?: number;
  documentId?: string;
  assignedToUserName?: string;
  assignedToUserId?: number;
  priorityName?: string;
  report?: IReport;
  mergedToReportId?: number;

  constructor(workflowItem: IWorkflowItemStep) {
    this.id = workflowItem.id;
    this.documentId = workflowItem?.workflowItem?.report?.documentId;
    this.assignedToUserName = workflowItem?.user?.userName;
    this.workflowStatus = workflowItem?.workflowStepStatus?.name;
    this.priorityName = workflowItem?.workflowItem?.report?.keywords?.priorityName;
    this.county = workflowItem?.workflowItem?.report?.keywords?.county?.description;
    this.dateOfCrash = workflowItem?.workflowItem?.report?.keywords?.dateOfCrash;
    this.reportId = workflowItem?.workflowItem?.reportId;
    this.crashReportId = workflowItem?.workflowItem?.report?.crashReportId;
    this.crashKey = workflowItem?.workflowItem?.report?.keywords?.crashKey;
    this.mergeStatus = workflowItem?.workflowItem?.report?.mergeStatus?.name;
    this.mergeStatusId = workflowItem?.workflowItem?.report?.mergeStatus?.id;
    this.involvedParties = workflowItem?.workflowItem?.report?.keywords?.involvedParties?.map(
      (ip) => [ip.firstName, ip.lastName, ip.businessName].join(" ")
    );
    this.mergedToReportId = workflowItem?.workflowItem?.report?.mergedToReportId;
    this.report = workflowItem?.workflowItem?.report;
  }
}
